/**
 * manager-groups-desktop.js
 */

import React from 'react';
import { 
  IconButton,
} from '@mui/material';
import { useHistory, Link } from 'react-router-dom';
import { UserContext } from 'contexts/user/user-context';
import FeatureBox from 'components/feature-box';
import Button from 'components/button';
import Icon from 'components/icon';
import DropMenu from 'components/drop-menu';
import IconTitle from 'components/icon-title';
import CaptionedSvg from 'components/captioned-svg';
import GroupListDesktop from '../group-list-desktop';
import GroupName from '../group-name';
import RequestType from '../request-type';
import { ManagerGroupsContext } from './manager-groups-context';
import { managerGroupRoute } from './manager-groups';
import ManagerGroupAdd from './manager-group-add';
import { ReactComponent as ProjectTeamSvg } from 'assets/images/project-team.svg';


export default function ManagerGroupsDesktop(props) {
  const { user } = React.useContext(UserContext);
  const { 
    managers,
    onDeleteRequest,
    onLeaveManager,
  } = React.useContext(ManagerGroupsContext);
  const history = useHistory();
  const [isLoading, setIsLoading] = React.useState(false);
  const columns = [{
    field: 'name',
    headerName: 'NAME',
    flex: 25,
    valueGetter: params => params.row.manager.name,
    renderCell: params => <GroupName
      name={params.value}
      decorators={!params.row.dateAccepted && <RequestType context='manager-group' request={params.row} />}
    />
  }, {
    field: 'role',
    headerName: 'MANAGER TYPE',
    flex: 10,
    valueGetter: params => params.value.name
  }, {
    field: 'handler-count-or-action',
    headerName: 'HANDLERS',
    flex: 8,
    type: 'number',
    valueGetter: params => params.row.members?.length || '-',
  }, {
    field: 'menu',
    headerName: ' ',
    sortable: false,
    align: 'right',
    flex: 10,
    renderCell: params => {
      let items = [];

      // VIEW
      if (params.row.dateAccepted || params.row.creator.id !== user.id) {
        items.push({
          key: 'view',
          name: <b>View</b>,
          icon: 'group-manager',
          component: Link,
          to: managerGroupRoute(params.row.id, params.row.role.id, history)
        });
      }

      // LEAVE
      if (params.row.dateAccepted) {
        items.push({
          key: 'leave',
          name: 'Leave ...',
          icon: 'group-leave',
          onSelect: () => onLeaveManager(params.row, setIsLoading)
        });
      }

      // REMOVE
      if (!params.row.dateAccepted) {
        items.push({
          key: 'remove',
          name: 'Remove ...',
          icon: 'close',
          onSelect: () => onDeleteRequest(params.row, setIsLoading)
        });
      }

      return (
        <DropMenu
          id={`${params.row.id}-menu`}
          label={<IconButton size='small'><Icon type='menu' /></IconButton>}
          items={items}
        />
      );
    }
  }];


  const rowUrl = (managerGroup) => {
    return managerGroup.dateAccepted || (managerGroup?.creator?.id && managerGroup?.creator?.id !== user.id) 
      ? managerGroupRoute(managerGroup.manager.id, managerGroup.role.id, history)
      : null;
  }


  return (
    <>
      <FeatureBox loading={isLoading}>
        <IconTitle
          iconType='group-manager'
          title='Managers'
          subtitle='Managers include supervisors or trainers that have access to your account in some way.'
          gutterBottom
          actions={<ManagerGroupAdd 
            menuLabel={<Button
              variant='contained'
              children='Manager'
              startIcon={<Icon type='add' />}
              endIcon={<Icon type='arrow-down' />}
            />} 
          />}
        />

        {managers.length === 0 &&
        <CaptionedSvg 
          image={<ProjectTeamSvg />} 
          text={<>You haven't added any managers. Use the <b>+ Manager</b> button to share your records with a supervisor or trainer.</>}
        />}

        {managers.length > 0 &&
        <GroupListDesktop
          width={750}
          rowUrl={rowUrl}
          rows={managers}
          columns={columns}
        />}
      </FeatureBox>
    </>
  )
}